export { default as component } from "../../../../src/routes/[prefix]/(main)/home/+page.svelte";